import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"


import CheckboxItem from './CheckboxItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxItemContainer',
  props: ['filterDataValues', 'field'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CheckboxItem, {
    "filter-data-values": __props.filterDataValues,
    field: __props.field
  }, null, 8, ["filter-data-values", "field"]))
}
}

})